import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';
import moment from 'moment'

import Vue from 'vue'

const getDefaultStateForDO = () => {
    return {
      dos: [],
      data:{},
      filter:{
            keyword:"",
            date_from:null,
            date_to:null,
            type:null
      }
    }
  }

const state = getDefaultStateForDO()

const mutations = {
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    FETCH_ALL(state, { data })
    {
      if(data)
      {
        data.forEach(function(element) {
            element.movement_date = (element.movement_date != null && element.movement_date != '') ? (moment(element.movement_date).format('DD/MM/YYYY')) : '-'
        });
        state.dos = data
      }
    },
    FETCH(state, data) {
        if (data) {
            state.data = data
        }
    }
}

const actions = {
    fetch({ commit }, data) {
        return axios.post(apiRoutes['STOCKCARDS_RETRIEVE'], data, authHeader())
            .then(response => {
                if (response.data.code == 1) {
                    commit('FETCH', response.data.data)
                } else {
                    commit('FETCH', {})
                }
            })
            .catch(error => {
                if (error.response) {
                    console.log(error.response)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    console.log("Problem Querying Data!", error);
                }
            });
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['QUICK_SEARCH_DOS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH_ALL', {data:response.data.data})
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('FETCH_ALL', {data:[]})
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
}

export {
    state,
    actions,
    mutations
}